import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};


const putAiAction = async({option, tcrid}) => {
    /*
    option : skip or delete or continue
     */
    const user = getUserDetails();
    const response = await axios.get(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=putAIAction&companyid=${user.companyid}&tcrid=${tcrid}&option=${option}`

    );

    return response.data;
}

const usePutAiActions = (options = {}) => {
  /* 
  using useMutation for get method, becuase it should have been a post request ideally
  but the backend supports only GET methods, so for me to show appropriate status on the ui, and
  invalidate queries so as to get the latest data, i'm using useMutation for Get method. 
  */

  return useMutation({
    queryKey: ["putAiAction"],
    mutationFn: putAiAction,
    ...options,
  });
};


export default usePutAiActions;